// ======================================================================
// File Name       : ExpiredTrialNavigatorConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as FUNCTION from './FunctionConstants';
import * as ICON from './IconConstants';
import * as Path from './PathConstants';

const EXPIRED_TRIAL_NAVIGATOR_CONFIG = [
  {
    title: 'トップ',
    path: Path.TOP_LIST,
    id: FUNCTION.TOP,
    icon: ICON.TOP,
    line: true
  },
  {
    title: 'サービス切り替え',
    path: Path.SERVICE_LOGIN_LIST,
    id: FUNCTION.SERVICE_LOGIN,
    icon: ICON.SERVICE,
    line: true
  },
  {
    title: 'ユーザー管理',
    path: Path.USER_LIST,
    id: FUNCTION.USER_LIST,
    icon: ICON.USER,
  },
];
  
  export default EXPIRED_TRIAL_NAVIGATOR_CONFIG;